
import { captureException as captureException_1 } from "@sentry/react";

export function isEnabled() {
    return (window.SENTRY_DSN || '') !== "";
}

export function captureException(ex) {
    if (isEnabled()) {
        captureException_1(ex);
    }
}

//# sourceMappingURL=ErrorReporting.js.map
